













































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import ApiFactory from "@/api/ApiFactory";
import { PerformanceChartDataDto } from "@/api/ClientPortalApiClient";

@Component
export default class FundValuePerformanceChart extends Vue {
  @Prop() policyId: number | undefined;

  private performanceChartData: PerformanceChartDataDto | null = null;
  private showIndividualFunds: boolean = false;
  private noData: boolean = false;
  private perfChartOptions = {
    legend: {
      position: "bottom"
    },
    dataLabels: {
      enabled: true
    },
    chartArea: {
      top: 20,
      left: 40,
      right: 20
    },
    animation: {
      duration: 500,
      startup: true,
      easing: "out"
    }
  };

  async mounted() {
    await this.getFundPerformance();
  }

  private async getFundPerformance() {
    if (!this.policyId) throw new Error("Policy id not valid");
    const api = ApiFactory.CreateDataClient();
    try {
      const perfData = await api.funds_GetFundValuePerformance(
        this.policyId,
        12
      );
      if (perfData) {
        this.performanceChartData = perfData;
      } else {
        this.noData = true;
      }
    } catch (e) {
      this.noData = true;
    }
  }
}
